import type { WsOrderBookResponse } from '@/utils/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useOrderBookStore = defineStore('ob-store', () => {
  const orderbooks = ref<Record<string, WsOrderBookResponse>>({})

  const set = (exchange: string, marketType: string, asset: string, ob: WsOrderBookResponse) => {
    const cacheKey = `${exchange}/${marketType}/${asset}`.toLowerCase()
    orderbooks.value[cacheKey] = ob
  }

  const get = (exchange: string, marketType: string, asset: string) => {
    const cacheKey = `${exchange}/${marketType}/${asset}`.toLowerCase()
    return orderbooks.value[cacheKey] ?? undefined
  }

  const exists = (exchange: string, marketType: string, asset: string) => {
    const cacheKey = `${exchange}/${marketType}/${asset}`.toLowerCase()
    return cacheKey in orderbooks.value
  }

  return {
    orderbooks,
    set,
    get,
    exists,
  }
})
